var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4678 0.442623C12.5898 0.56459 12.6583 0.729989 12.6583 0.90245C12.6583 1.07491 12.5898 1.24031 12.4678 1.36228L5.31353 8.51658C5.19156 8.63851 5.02616 8.70701 4.8537 8.70701C4.68124 8.70701 4.51584 8.63851 4.39387 8.51658L1.14192 5.26463C1.0798 5.20463 1.03025 5.13286 0.996163 5.05351C0.962076 4.97416 0.944134 4.88882 0.943384 4.80246C0.942633 4.7161 0.95909 4.63046 0.991792 4.55053C1.02449 4.4706 1.07279 4.39798 1.13385 4.33691C1.19492 4.27584 1.26754 4.22755 1.34747 4.19485C1.4274 4.16215 1.51304 4.14569 1.5994 4.14644C1.68576 4.14719 1.77111 4.16513 1.85046 4.19922C1.92981 4.2333 2.00157 4.28285 2.06157 4.34497L4.8537 7.1371L11.5482 0.442623C11.6701 0.320694 11.8355 0.252197 12.008 0.252197C12.1805 0.252197 12.3459 0.320694 12.4678 0.442623Z",
    fill: "#30ECAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.b9cd3f326f03417ae6a2ce127ff89ab1.svg";
export { ForwardRef as ReactComponent };